import style from "./Styles/index.module.css";
import imgUser from "./Imgs/image-jeremy.png";
import bg5 from "./Imgs/icon-self-care.svg";
import bg3 from "./Imgs/icon-exercise.svg";
import bg4 from "./Imgs/icon-social.svg";
import bg2 from "./Imgs/icon-study.svg";
import bg1 from "./Imgs/icon-play.svg";
import bg0 from "./Imgs/icon-work.svg";
import {useState} from "react";

export default function Main() {
    const periods = ["day", "week", "month"];
    const bgImgs = [bg0,bg1,bg2,bg3,bg4,bg5];
    const data = JSON.parse('[{"title": "Work","timeframes": {"daily": {"current": 5, "previous": 7},"weekly": {"current": 32, "previous": 36},"monthly": {"current": 103, "previous": 128}}}, {"title": "Play","timeframes": {"daily": {"current": 1, "previous": 2}, "weekly": {"current": 10, "previous": 8}, "monthly": {"current": 23, "previous": 29}}}, {"title": "Study","timeframes": {"daily": {"current": 0, "previous": 1}, "weekly": {"current": 4, "previous": 7}, "monthly": {"current": 13, "previous": 19}}}, {"title": "Exercise","timeframes": {"daily": {"current": 1,"previous": 1},"weekly": {"current": 4,"previous": 5 },"monthly": {"current": 11,"previous": 18 } }}, {"title": "Social","timeframes": {"daily": {"current": 1,"previous": 3},"weekly": {"current": 5,"previous": 10}, "monthly": {"current": 21,"previous": 23}}}, {"title": "Self Care","timeframes": {"daily": {"current": 0,"previous": 1 },"weekly": {"current": 2,"previous": 2},"monthly": {"current": 7,"previous": 11}}}]');
    const [valueI, setValueI] = useState("daily");
    const [period, setPeriod] = useState(0);

    return (
        <main>
            <aside>
                <article className={style.inforsUser}>
                    <img src={imgUser} alt="" />
                    <article>
                        <p>Report for</p>
                        <h1>Jeremy Robson</h1>
                    </article>
                </article>
                <ul>
                    <li className={`${style.liBtn}${period === 0}`} onClick={() => {
                        setValueI("daily");
                        setPeriod(0);
                    }}>Daily</li>
                    <li className={`${style.liBtn}${period === 1}`} onClick={() => {
                        setValueI("weekly");
                        setPeriod(1);
                    }}>Weekly</li>
                    <li className={`${style.liBtn}${period === 2}`} onClick={() => {
                        setValueI("monthly");
                        setPeriod(2);
                    }}>Monthly</li>
                </ul>
            </aside>
            <section className={style.gridInfors}>
                {data.map((j, i) => {
                    return (
                        <section className={`${style.itemGrid}${i}`} key={j.title}>
                            <div className={style.divImgTop}><img className={style.imgTop} src={bgImgs[i]} alt="" /></div>
                            <section className={style.infors}>
                                <article className={style.title}>
                                    <h3>{j.title}</h3>
                                    <svg width="21" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm8 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm8 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" fill="#BBC0FF" fill-rule="evenodd"/></svg>
                                </article>
                                <article>
                                    <h2>{j.timeframes[valueI].current}hrs</h2>
                                    <p className={style.period}>Last {periods[period]} - {j.timeframes[valueI].previous}hrs</p>
                                </article>
                            </section>
                        </section>
                    )
                })}
            </section>
        </main>
    );
}